import React from 'react';
import BookingsMobile from './BookingsMobile';
import BookingsDesktop from './BookingsDesktop';

const Bookings = () => {
  return (
    <div>
      <div className={`hidden lg:flex flex-col`}>
        <BookingsDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <BookingsMobile />
      </div>
    </div>
  );
};

export default Bookings;
